<mat-menu #matMenu xPosition="before">
  @if (menu.id !== 'root' && !isSubMenu) {
    <!-- this was pinned -->
     <button mat-menu-item disabled>
      @if (menu.icon) {
        <mat-icon
          [style.opacity]="menu.iconOpacity ?? 1"
          [style.color]="menu.iconColor"
          >{{menu.icon}}</mat-icon>
      }

      {{ menu.pinnedLabel ?? menu.label }}
    </button>
     <mat-divider></mat-divider>
  }

  @for (subitem of menu.items; track subitem) {
    @if (!subitem.hidden) {
      @if (subitem.type === 'menu') {
        <tyt-dev-tools-menu
          [parentMenu]="this"
          [menu]="subitem" [isSubMenu]="true"
          />
      }
      @if (subitem.type === 'action') {
        <button
          mat-menu-item
          (click)="subitem.handler(subitem, injector)"
          >
          @if (subitem.icon) {
            <mat-icon>{{subitem.icon}}</mat-icon>
          }
          {{subitem.label}}
        </button>
      }
    }
  }

  @if (menu.id !== 'root') {
    <mat-divider></mat-divider>
    @if (isSubMenu) {
      <button mat-menu-item (click)="devTools.pinMenu(menu)">
        <mat-icon>push_pin</mat-icon>
        <em>Pin this menu</em>
      </button>
    } @else {
      <button mat-menu-item (click)="devTools.unpinMenu(menu)">
        <mat-icon>push_pin</mat-icon>
        <em>Unpin this menu</em>
      </button>
    }
  } @else {
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="devTools.resetPinnedMenus()">
      <mat-icon>push_pin</mat-icon>
      <em>Reset pins</em>
    </button>
  }
</mat-menu>

@if (isSubMenu) {
  <button mat-menu-item [matMenuTriggerFor]="matMenu" #trigger="matMenuTrigger" (mouseenter)="hovered()">
    @if (menu.icon) {
      <mat-icon [style.opacity]="menu.iconOpacity" [style.color]="menu.iconColor">{{menu.icon}}</mat-icon>
    }
    {{menu.label}}
  </button>
}

@if (!isSubMenu) {
  <button class="root-button" mat-icon-button [matMenuTriggerFor]="matMenu" [attr.aria-label]="menu.label" (click)="initialize()">
    <mat-icon
      [style.opacity]="menu.pinnedIconOpacity ?? menu.iconOpacity ?? 1"
      [style.color]="menu.pinnedIconColor ?? menu.iconColor"
      >{{menu.pinnedIcon ?? menu.icon}}</mat-icon>
  </button>
}